import { Link } from "react-router-dom";

const STATS = [
  { value: "1200+", label: "娱乐内容", icon: "ri-video-line" },
  { value: "38万", label: "月活跃用户", icon: "ri-user-smile-line" },
  { value: "每天", label: "持续更新", icon: "ri-refresh-line" },
  { value: "100%", label: "轻松免费", icon: "ri-gift-line" },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="rounded-lg bg-background-100 border border-background-200 px-6 md:px-12 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
            <i className="ri-emotion-happy-line" />
            关于羞羞网站
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-5 leading-snug">
            我们只做一件事，让你轻松笑一笑
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
            羞羞网站是一个综合娱乐内容聚合平台，汇集趣味视频、搞笑段子与轻松访谈。
            我们希望成为你忙碌生活里的那个小小出口：通勤路上、午休间隙、睡前十分钟，
            随时打开，随时放松。
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              探索内容
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50 border border-background-200 p-5 flex flex-col gap-2"
            >
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className={`${stat.icon} text-xl`} />
              </span>
              <span className="font-heading font-bold text-2xl text-foreground-950">{stat.value}</span>
              <span className="text-xs text-foreground-600">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}